import { PLAN_STATE, useSubscriptionInfo } from "@next-platform/client-common-core";
import { Button, ButtonVariant, IconVariants, Text, TextVariants } from "@next-platform/client-common-spicy-ui";

import { Col } from "@/components/customComponents";
import { LocalizedLink } from "@/components/LocalizedLink/LocalizedLink";
import Trans from "@/components/Trans/Trans";
import { ROUTES } from "@/constants";

import SubscriptionPlanDetails from "./SubscriptionPlanDetails";
import SubscriptionPlanFooter from "./SubscriptionPlanFooter";
import SubscriptionPlanGuidance from "./SubscriptionPlanGuidance";
import SubscriptionPlanHero from "./SubscriptionPlanHero";

const PROGRESS_PERCENT_MAX = 100;

const SubscriptionPlanPage = () => {
  const { planState, daysRemaining, progressPercent, formattedExpiryDate, planName, subscriptionPlanName, planRole, displayPlanRole, displayPlanName, hasExpiryDate } =
    useSubscriptionInfo();

  const oneTimePlanState = planState === PLAN_STATE.EXPIRED ? PLAN_STATE.EXPIRED : PLAN_STATE.ONE_TIME_ACTIVE;
  const isExpiredPlan = oneTimePlanState === PLAN_STATE.EXPIRED;
  const progressValue = isExpiredPlan ? PROGRESS_PERCENT_MAX : progressPercent;

  return (
    <div className="flex justify-center">
      <Col className="gap-lg w-[558px] max-w-full px-4 py-6 max-mob:p-0 items-start" data-testid="SubscriptionPlan-Page">
        <Button
          as={LocalizedLink}
          to={ROUTES.profile}
          variant={ButtonVariant.TRANSPARENT}
          iconStart={IconVariants.CHEVRON_LEFT}
          data-testid="SubscriptionPlan-BackButton"
          className="pl-0 !text-gray-11"
        >
          <Trans i18nKey="subscription:overview.backToProfileSettings" />
        </Button>

        <Col className="gap-1">
          <Text variant={TextVariants.HEADING_1_BOLD} className="text-heading-4">
            <Trans i18nKey="subscription:overview.title" />
          </Text>
          <Text variant={TextVariants.PARAGRAPH_SMALL_REGULAR} className="text-gray-11">
            <Trans i18nKey="subscription:overview.subtitle" />
          </Text>
        </Col>

        <div className="rounded-2xl border border-solid border-gray-6 bg-gray-3 overflow-hidden" data-testid="SubscriptionPlan-PlanCard">
          <SubscriptionPlanHero
            planRole={displayPlanRole}
            planState={oneTimePlanState}
            planName={displayPlanName}
            daysRemaining={daysRemaining}
            progressValue={progressValue}
            formattedExpiryDate={formattedExpiryDate}
            hasExpiryDate={hasExpiryDate}
          />
          <Col className="gap-lg p-lg bg-gray-3">
            <SubscriptionPlanDetails
              planRole={planRole}
              tierRole={displayPlanRole}
              planState={oneTimePlanState}
              planName={planName}
              previousPlanName={subscriptionPlanName}
            />
            <SubscriptionPlanGuidance planRole={displayPlanRole} planState={oneTimePlanState} />
            <SubscriptionPlanFooter planState={oneTimePlanState} planRole={displayPlanRole} />
          </Col>
        </div>
      </Col>
    </div>
  );
};

export default SubscriptionPlanPage;
